export default __webpack_public_path__ + "static/media/welcomeBack.01eaa624.svg";